/*
 * @Descripttion: 
 * @version: 
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2025-07-18 09:40:23
 * @LastEditors: linxi
 * @LastEditTime: 2025-07-21 09:42:38
 */
import { createAsyncThunk } from '@reduxjs/toolkit'
import _ from 'lodash'
import { sendAsync } from '../../../app/applicationSlice'
import { RootThunkApi } from '../../../app/store'
import {
  DBManagementListParams,
  getDBManagementList,
  getDBManagementDetail,
  SubmitParams,
  getDBManagementSubmit,
  getDBManagementExport,
  getRemove,
  getExamine,
  getBreakage,
} from '../../../services/disqualificationBreakageManagement'

// 列表
export const getDBManagementListAsync = createAsyncThunk<
  void,
  DBManagementListParams,
  RootThunkApi<void>
>('DBManagement/getDBManagementListAsync', async (params, api) => {
  return sendAsync(getDBManagementList(params), api)
})

// 详情
export const getDBManagementDetailAsync = createAsyncThunk<
  void,
  any,
  RootThunkApi<void>
>('DBManagement/getDBManagementDetailAsync', async (params, api) => {
  return sendAsync(getDBManagementDetail(params), api)
})

// 保存编辑
export const getDBManagementSubmitAsync = createAsyncThunk<
  void,
  SubmitParams,
  RootThunkApi<void>
>('DBManagement/getDBManagementSubmitAsync', async (params, api) => {
  return sendAsync(getDBManagementSubmit(params), api)
})

//导出
export const getDBManagementExportAsync = createAsyncThunk<
  void,
  DBManagementListParams,
  RootThunkApi
>('DBManagement/getDBManagementExportAsync ', async (params, api) => {
  return sendAsync(getDBManagementExport(params), api)
})

// 删除
export const getRemoveAsync = createAsyncThunk<void, any, RootThunkApi<void>>(
  'DBManagement/getRemoveAsync',
  async (params, api) => {
    return sendAsync(getRemove(params), api)
  }
)

// 审核
export const getExamineAsync = createAsyncThunk<void, any, RootThunkApi<void>>(
  'DBManagement/getExamineAsync',
  async (params, api) => {
    return sendAsync(getExamine(params), api)
  }
)

// 报损
export const getBreakageAsync = createAsyncThunk<void, any, RootThunkApi<void>>(
  'DBManagement/getBreakageAsync',
  async (params, api) => {
    return sendAsync(getBreakage(params), api)
  }
)
